import { withCommonMoveSetup } from './moveDecorator.js';

/** Insomnia ability data. Prevents sleep (full implementation can be added later). */
export const INSOMNIA_ABILITY = {
    identifier: 'insomnia',
    name: 'Insomnia',
    description: 'Prevents the Pokémon from falling asleep.',
};

/**
 * Custom implementation for Worry Seed.
 * Changes the target's ability to Insomnia until the target is switched out or the battle ends.
 * Uses the transient ability override; resetVolatileStatuses() clears it on switch/battle end.
 */
export default class WorrySeed {
    static customMoveLogic(battleStateMachine, move, attacker, defender) {
        if (defender.ability?.identifier === 'insomnia') {
            battleStateMachine.context.actions.push(
                battleStateMachine.ag.readText('It had no effect!', { delay: 50 })
            );
            return;
        }
        battleStateMachine.context.actions.push(
            battleStateMachine.ag.readText(`${defender.name}'s Ability was changed to Insomnia!`, {
                delay: 50,
            }),
            battleStateMachine.ag.script(() => {
                defender.setAbilityOverride(INSOMNIA_ABILITY);
                if (defender.status1?.id === 'sleep') {
                    defender.status1 = null;
                    battleStateMachine.context.actions.push(
                        battleStateMachine.ag.readText(
                            `${defender.name}'s Insomnia woke it up!`,
                            { delay: 50 }
                        )
                    );
                }
            })
        );
    }

    static setUpBattleActions = withCommonMoveSetup(WorrySeed.customMoveLogic);
}
